import $ from 'jquery';
import { animationSpeed } from '../_helpers/constants';

export const x = (selector, context = document) => context.querySelectorAll(selector);

export const x0 = (selector, context = document) => context.querySelector(selector);

export const isTouch = (() =>
  'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0)();

export const getOffsetTop = (elem) => {
  let offsetTop = 0;
  do {
    if (!isNaN(elem.offsetTop)) {
      offsetTop += elem.offsetTop;
    }
  } while ((elem = elem.offsetParent));
  return offsetTop;
};

export const getScrollTop = () => {
  if (typeof pageYOffset != 'undefined') {
    return pageYOffset;
  } else {
    let doc = document,
      B = doc.body,
      D = doc.documentElement;

    D = D.clientHeight ? D : B;
    return D.scrollTop;
  }
};

export const encodeURLComponent = (str) => {
  return encodeURIComponent(str).replace(/[!'()*]/g, escape);
};

export const getParametersFromURL = () => {
  let re = /(?:\?|&(?:amp;)?)([^=&#]+)(?:=?([^&#]*))/g,
    match,
    params = {},
    url = document.location.href,
    decode = (s) => decodeURIComponent(s.replace(/\+/g, ' '));

  while ((match = re.exec(url))) {
    if (!params[decode(match[1])]) {
      params[decode(match[1])] = [];
    }
    params[decode(match[1])].push(decode(match[2]));
  }

  return params;
};

export const closest = (el, parentClass) => {
  do {
    if (el.classList && el.classList.contains(parentClass)) {
      return el;
    }
  } while ((el = el.parentNode));

  return null;
};

export const minmax = (value, min, max) => {
  if (parseInt(value) < min || isNaN(parseInt(value))) return min;
  else if (parseInt(value) > max) return max;
  else return value;
};

export const setScrollTop = (offset = 0) => {
  document.documentElement.scrollTop = document.body.scrollTop = offset;
};

export const getSiblings = (elem) => {
  const siblings = [];
  let sibling = elem.parentNode.firstChild;
  while (sibling) {
    if (sibling.nodeType === 1) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling;
  }
  return siblings;
};

export const capitalize = (string) => {
  return string.charAt(0).toUpperCase() + string.toLowerCase().slice(1);
};

export const addUrlPart = (baseUrl, value) => {
  return new URL(value, baseUrl);
};

export const isDesktop = () => window.innerWidth >= 1024;
export const isMobile = () => window.innerWidth <= 768;
export const isIOS = (() => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream)();
export const isIE11 = !!(
  navigator.userAgent.match(/Trident/) && navigator.userAgent.match(/rv[ :]11/)
);

export const highLightSelected = (items, index, activeClassName) => {
  $(items).removeClass(activeClassName);
  $(items[index]).addClass(activeClassName);
};

export const dateDiff = (dateA, dateB) => {
  const date1 = new Date(dateA);
  const date2 = new Date(dateB);
  const diff = date2.getTime() - date1.getTime();
  return diff / (1000 * 3600 * 24);
};

export const percentageCalc = (val1, val2) => {
  return (val2 * 100) / val1;
};

export const numberCalc = (value, percentage) => {
  return (value * percentage) / 100;
};

export const ucWords = (text) => {
  return text.replace(/\w\S*/g, (w) => w.replace(/^\w/, (c) => c.toUpperCase()));
};

export const scrollTo = (xScroll = 0, yScroll = 0) => {
  if (navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/)) {
    window.scrollTo(xScroll, yScroll);
  } else {
    $('html, body').animate(
      {
        scrollTop: xScroll,
      },
      animationSpeed
    );
  }
};

export const getUserUtcOffset = () => {
  return new Date().getTimezoneOffset() * -60;
}
